import Link from '@/routing/Link'
import { ArrowLeft } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'

export function BackToLogin() {
  const { t } = useTranslation('auth')

  return (
    <div className="flex justify-center pt-2">
      <Button variant="link" size="sm" className="gap-1.5 p-0 text-sm" asChild>
        <Link href="/login">
          <ArrowLeft className="size-4" />
          {t('backToSignIn')}
        </Link>
      </Button>
    </div>
  )
}
